export default __webpack_public_path__ + "static/media/donkey-rocks.2afbb063.svg";